import React, { useState } from 'react';
import { 
  Container, 
  Paper, 
  Typography, 
  TextField, 
  Button, 
  Alert, 
  Box, 
  CircularProgress 
} from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import axios from '../utils/axiosConfig';
import Logo from '../components/Logo';
import Footer from '../components/Footer';

const ForgotPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' } | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage(null);

    try {
      const response = await axios.post(`/api/password-reset/request`, { email }, {
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      setMessage({ 
        text: response.data.message || 'Eine E-Mail mit einem Code zum Zurücksetzen des Passworts wurde gesendet.', 
        type: 'success' 
      });
      
      // Nach erfolgreicher Anforderung zur Code-Eingabe weiterleiten
      setTimeout(() => {
        navigate('/reset-password', { state: { email } });
      }, 2000);
      
    } catch (error: any) {
      setMessage({ 
        text: error.response?.data?.message || 'Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.', 
        type: 'error' 
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      minHeight: '100vh',
      bgcolor: 'background.default'
    }}>
      <Box sx={{ 
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        pt: 4, pb: 2
      }}>
        {/* Logo und Titel */}
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center',
          mb: 2 
        }}>
          <Logo height={80} />
          <Typography variant="h4" component="h1" textAlign="center" gutterBottom>
            Meldeportal Trampolin
          </Typography>
        </Box>
      
        <Container component="main" maxWidth="sm">
          <Paper elevation={6} sx={{ padding: 4, display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
            <Typography variant="h4" gutterBottom>
              Passwort zurücksetzen
            </Typography>
            
            <Typography variant="body1" sx={{ mb: 4 }}>
              Gib Deine E-Mail-Adresse ein. DDu erhätst einen Code zum Zurücksetzen Seines Passworts.
            </Typography>

            {message && (
              <Alert severity={message.type} sx={{ width: '100%', mb: 2 }}>
                {message.text}
              </Alert>
            )}

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%' }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="E-Mail-Adresse"
                name="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Code senden'}
              </Button>
            </Box>

            <Box mt={2} textAlign="center">
              <Typography variant="body2">
                <Button 
                  component={Link} 
                  to="/login" 
                  color="primary"
                  sx={{ 
                    textTransform: 'none',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  Zurück zum Login
                </Button>
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>
      
      {/* Footer am Ende der Seite */}
      <Box sx={{ mt: 'auto' }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default ForgotPassword;